// extracted by mini-css-extract-plugin
export var copyableField = "_qs-4";
export var customerBadge = "_qs-0";
export var customerInfoTitle = "_qs-2";
export var details = "_qs-1";
export var dropdownContainer = "_qs-5";
export var dropdownImage = "_qs-6";
export var editAssigneeForm = "_qs-a";
export var editButton = "_qs-3";
export var email = "_qs-7";
export var hidden = "_qs-d";
export var input = "_qs-8";
export var saveButton = "_qs-b";
export var shopifyIcon = "_qs-c";
export var suggestionBadge = "_qs-e";
export var suggestionText = "_qs-f";
export var username = "_qs-9";